module.exports = __webpack_public_path__ + "static/bablic-f91ddd305b3e5c227fb70aaa9156bd0e.png";